import React, { createContext, useContext, useState } from 'react';
import UpgradeModal from '../components/Companies/UpgradeModal/UpgradeModal';

const UpgradeModalContext = createContext();

export const UpgradeModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: null,
    feature: null
  });

  const showUpgradeModal = (feature, customTitle = null) => {
    setModalConfig({
      title: customTitle,
      feature
    });
    setIsOpen(true);
  };

  const hideUpgradeModal = () => {
    setIsOpen(false);
    // Reset config after modal closes
    setTimeout(() => {
      setModalConfig({ title: null, feature: null });
    }, 300);
  };

  const value = {
    showUpgradeModal,
    hideUpgradeModal,
    isOpen,
  };

  return (
    <UpgradeModalContext.Provider value={value}>
      {children}
      <UpgradeModal
        open={isOpen}
        title={modalConfig.title}
        feature={modalConfig.feature}
        onClose={hideUpgradeModal}
      />
    </UpgradeModalContext.Provider>
  );
};

export const useUpgradeModal = () => {
  const context = useContext(UpgradeModalContext);
  if (!context) {
    throw new Error('useUpgradeModal must be used within an UpgradeModalProvider');
  }
  return context;
};

export default UpgradeModalContext;
